module.exports = __webpack_public_path__ + "static/envelope-beneath-dca4119939e3ca857c46ee1f2de9b87b.webp";